import { Box, HStack } from "@chakra-ui/react";
import { useEffect, useRef } from "react";
import "./index.css";
import tinycolor from "tinycolor2";

/**
 * @typedef {Object} AnimatedLineLoaderProps
 * @property {boolean} [isLoading=true]
 */

/**
 *
 * @param {AnimatedLineLoaderProps & import("@chakra-ui/react").StackProps} props
 * @returns
 */
export default function AnimatedLineLoader(props) {
  const { isLoading = true, ...restProps } = props;
  const sizes = [30, 90]; // Width percentages
  const colors = ["#1f75ff", "#c71fff"];
  const leftBoxRef = useRef();

  useEffect(() => {
    if (!leftBoxRef.current) return;

    let colorIndex = 0;
    let colorDirection = 1;
    let sizeIndex = 0;
    let sizeDirection = 1;
    let colorInterval, widthInterval;

    const applyState = () => {
      if (!leftBoxRef.current) return;
      leftBoxRef.current.style.setProperty("--start-color", colors[colorIndex]);
      leftBoxRef.current.style.setProperty("width", `${sizes[sizeIndex]}%`);
    };

    if (isLoading) {
      // ✅ Apply immediately — no initial delay
      applyState();

      // Start intervals
      colorInterval = setInterval(() => {
        if (!leftBoxRef.current) return;

        colorIndex += colorDirection;
        if (colorIndex >= colors.length - 1 || colorIndex <= 0) {
          colorDirection *= -1;
        }

        leftBoxRef.current.style.setProperty(
          "--start-color",
          colors[colorIndex]
        );
      }, 500);

      widthInterval = setInterval(() => {
        if (!leftBoxRef.current) return;

        sizeIndex += sizeDirection;
        if (sizeIndex >= sizes.length - 1 || sizeIndex <= 0) {
          sizeDirection *= -1;
        }

        leftBoxRef.current.style.setProperty("width", `${sizes[sizeIndex]}%`);
      }, 500);
    } else {
      // ✅ Stop animations immediately if loading stops
      if (colorInterval) clearInterval(colorInterval);
      if (widthInterval) clearInterval(widthInterval);
    }

    // Cleanup on unmount or isLoading change
    return () => {
      if (colorInterval) clearInterval(colorInterval);
      if (widthInterval) clearInterval(widthInterval);
    };
  }, [isLoading]);

  return (
    <HStack h="2px" w="full" pos="relative" {...restProps}>
      <Box
        ref={leftBoxRef}
        transition="--start-color 0.5s ease, width 0.5s ease, opacity 0.3s ease"
        background="radial-gradient(circle, var(--start-color) 20%, #161618)"
        pos="absolute"
        left="50%"
        top="50%"
        transform="translate(-50%, -50%)"
        h="full"
        w={`${sizes[0]}%`}
        filter="blur(1.5px)"
        opacity={isLoading ? 1 : 0}
      />
    </HStack>
  );
}
